﻿// tslint:disable:max-line-length
import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { IConfiguratorScope } from "@app/views/products/configurator.view";
import { Configurator, Page } from "@models";
import * as angular from "angular";

interface IPageScope extends IConfiguratorScope {
    _page: Page;
}

@NgComponent({
    token: Token.KbPage,
    dependencies: [
    ]
})
export class KbPage extends Directive {
    constructor() {
        super();

        this.replace = true;
        this.restrict = "E";
        this.scope = true;

        this.controller = [
            "$scope",
            "$element",
            "$attrs",
            "$templateCache",
            Token.$Compile.key,
            Token.$Http.key,
            "$controller",
            Token.$Timeout.key,
            "$animate",
            "$transclude",
            (
                $scope: IPageScope,
                $element: ng.IAugmentedJQuery,
                $attrs: ng.IAttributes,
                $templateCache: ng.ITemplateCacheService,
                $compile: ng.ICompileService,
                $http: ng.IHttpService,
                $controller: ng.IControllerService,
                $timeout: ng.ITimeoutService,
                $animate: ng.animate.IAnimateService,
                $transclude: ng.ITranscludeFunction) => {

                let pageDb: { [pageIden: string]: { scope: IPageScope; template?: ng.IAugmentedJQuery; } } = {};
                let oldTemplate: ng.IAugmentedJQuery;
                let newTemplate: ng.IAugmentedJQuery;
                let oldTemplateScope: IPageScope;
                let newTemplateScope: IPageScope;

                // because multiple instances of a nested configurator have the same page id, 
                // we need to hash it with the configurator name
                let getPageIdentifier = (page: Page) => {
                    return page.$parentConfigurator.name + "-" + page.id;
                };

                //cache the compiled template since it doesn't change
                let origTemplate = angular.element(Dirs.component("kb-page"));
                let compiled = $compile(origTemplate);

                // pick the right properties page template
                let updateTemplate = () => {
                    oldTemplate = newTemplate;
                    oldTemplateScope = newTemplateScope;

                    // if (oldTemplate) {
                    //     oldTemplate.removeClass("active");
                    //     // $timeout(() => {
                    //     //    oldTemplate.remove();
                    //     //    if (oldTemplateScope) {
                    //     //        oldTemplateScope.$destroy();
                    //     //        oldTemplateScope = null;
                    //     //    }
                    //     // }, 100);
                    // }
                        
                    // create the new template
                    if ($scope.selected && $scope.selected.page) {
                        let pageIden = getPageIdentifier($scope.selected.page);
                        if (pageDb[pageIden]) {
                            newTemplate = pageDb[pageIden].template;
                            newTemplateScope = pageDb[pageIden].scope;
                        } else {
                            // newTemplate = angular.element(Dirs.component("kb-page"));
                            // let compiled = $compile(newTemplate);
                            newTemplateScope = $scope.$new() as IPageScope;
                            compiled(newTemplateScope, (clonedElement, scope) => {
                                clonedElement.addClass("kb-page-control__page--initializing");
                                $element.append(clonedElement);
                                pageDb[pageIden] = {
                                    scope: newTemplateScope,
                                    template: clonedElement
                                };
                                newTemplate = clonedElement;
                            });
                            // add it to element
                            // $element.append(newTemplate);

                            
                        }

                        newTemplateScope._page = $scope.selected.page;
                        //$timeout(() => newTemplate.addClass("active"), 0);

                        //$timeout(() => {
                            let oldPage = oldTemplateScope ? oldTemplateScope._page : null;
                            let newPage = newTemplateScope._page;
                            let oldPageIndex = this.getHierarchicalIndex(oldPage);
                            let newPageIndex = this.getHierarchicalIndex(newPage);
                            let $oldPageEl = oldTemplate;
                            let $newPageEl = newTemplate;

                            $newPageEl.removeClass("kb-page-control__page--initializing");
                            newPage && $newPageEl.css("transition", "none");
                            if (this.isIndexGreater(newPageIndex, oldPageIndex)) {
                                //oldPage && $oldPageEl.css("transform", "translate3d(-100%,0,0)");
                                newPage && $newPageEl.css("transform", "translate3d(100%,0,0)");
                            } else {
                                newPage && $newPageEl.css("transform", "translate3d(-100%,0,0)");
                            }

                            //if (newPage) newPage.selected = true;
                            if (newTemplate) newTemplate.addClass("kb-page-control__page--selected");

                            setTimeout(() => {
                                //animate the height also.     
                                // let currentHeight = oldPage && $oldPageEl.outerHeight();
                                // newPage && $newPageEl.css("position", "relative");
                                // let newHeight = newPage && $newPageEl.outerHeight(); 
                                // newPage && $newPageEl.css("position", "absolute");
                                // $container.height(currentHeight);

                                if (this.isIndexGreater(newPageIndex, oldPageIndex)) {
                                    oldPage && $oldPageEl.css("transform", "translate3d(-100%,0,0)");
                                } else {
                                    oldPage && $oldPageEl.css("transform", "translate3d(100%,0,0)");
                                }
                                newPage && $newPageEl.css("transition", "");
                                newPage && $newPageEl.css("transform", "translate3d(0,0,0)");

                                // $container.height(newHeight);

                                // $timeout(() => {
                                //     if (oldPage) oldPage.selected = false;
                                //     //on the first run the new tab element might not have existed until now, so we refresh the reference
                                //     $newPageEl = newTab && $element.find(`#tab-${newTab.$id}`);
                                //     newPage && $newPageEl.css("position", "relative");
                                //     oldPage && $oldPageEl.css("position", "absolute");

                                //     $container.height("auto");
                                //     locked = false;
                                // }, 300);

                                setTimeout(() => {
                                    if (oldTemplate) oldTemplate.removeClass("kb-page-control__page--selected");
                                }, 300);
                            }, 0);
                        //});


                    }
                };

                $scope.selected.pageChanged.add(args => {
                    updateTemplate();
                });

                $scope.$on("$destroy", () => {
                    Object.keys(pageDb).forEach(key => {
                        if (pageDb[key].scope) pageDb[key].scope.$destroy();
                    });
                    pageDb = null;
                });

                updateTemplate();
            }];
    }

    public getHierarchicalIndex(parent: Page | Configurator): number[] {
        let indexMap = [];
        
        while (parent && parent.$parent) {
            let index = 0;
            if (parent instanceof Page) {
                index = (parent.$parent as Page | Configurator).pages.indexOf(parent);
            } else if (parent instanceof Configurator) {
                index = (parent.$parent as Page | Configurator).configurators.indexOf(parent);
            } else {
                throw "unexpected parent type";
            }
            indexMap.unshift(index);
            parent = parent.$parent as Page | Configurator;
        }

        return indexMap;
    }

    public isIndexGreater(thisIndex: number[], otherIndex: number[]) {
        for (let i = 0; i < thisIndex.length; i++) {
            if (otherIndex.length == i) return true;
            if (thisIndex[i] < otherIndex[i]) return false;
            if (thisIndex[i] > otherIndex[i]) return true;
        }
        return false;
    }
}
